function updateFinialImages(color) {
    if (!color) return;
    const dayVersion = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
    const cdn = 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/';
    const img = (src) => `<img src="${cdn}${src}" width="130" height="130">`;

    if (color === 'Lyne-Black' || color === 'Lyne-White' || color === 'Zoe-Black') {
        jQuery('input[name="mtsi_finial_style"][value="Ball Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Ball-Finial.jpg?v=${dayVersion}`));
        jQuery('input[name="mtsi_finial_style"][value="Cylinder Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Cylinder-Finial.jpg?v=${dayVersion}`));
        jQuery('input[name="mtsi_finial_style"][value="Ellipse Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Ellipse-Finial.jpg?v=${dayVersion}`));
        jQuery('input[name="mtsi_finial_style"][value="End Cap Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-End-Cap-Finial.jpg?v=${dayVersion}`));

    } else if (color === 'Lyne-Champagne' || color === 'Lyne-Gold' || color === 'Lyne-Silver' || color === 'Zoe-Gold') {
        jQuery('input[name="mtsi_finial_style"][value="Crown Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Crown-Finial.jpg?v=${dayVersion}`));
        jQuery('input[name="mtsi_finial_style"][value="Crystal Ball Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Crystal-Ball-Finial.jpg?v=${dayVersion}`));
        jQuery('input[name="mtsi_finial_style"][value="Ellipse Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Ellipse-Finial.jpg?v=${dayVersion}`));
        jQuery('input[name="mtsi_finial_style"][value="End Cap Finial"]').siblings('.wpcf7-list-item-label').html(img(`${color}-End-Cap-Finial.jpg?v=${dayVersion}`));
    }
    if(color.includes('Lyne')){
    jQuery('input[name="mtsi_ring_option"][value="Metal Rings"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Metal-Rings.jpg?v=${dayVersion}`));
    jQuery('input[name="mtsi_ring_option"][value="No rings"]').siblings('.wpcf7-list-item-label').html(img(`No-Rings.jpg?v=${dayVersion}`));
    }
    if(color.includes('Zoe')){
    jQuery('input[name="mtsi_runner_type"][value="Pleat Runners"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Pleat-Runners.jpg?v=1${dayVersion}`));
    jQuery('input[name="mtsi_runner_type"][value="S Fold Runners"]').siblings('.wpcf7-list-item-label').html(img(`${color}-S-Fold-Runners.jpg?v=1${dayVersion}`));
    }

    jQuery('input[name="mtsi_rod_type"][value="Single Rod"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Single-Rod.jpg?v=${dayVersion}`));
    jQuery('input[name="mtsi_rod_type"][value="Double Rod"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Double-Rod.jpg?v=${dayVersion}`));
}

jQuery(document).ready(function ($) {

// =====================
// 货币转换工具
// =====================
const CurrencyUtils = {
  getActive() {
    return window.Shopify?.currency?.active || 'USD';
  },
  getRate() {
    return parseFloat(window.Shopify?.currency?.rate || '1.0');
  },

  // 传入美元金额（非 cents）
  convert(priceInDollars) {
    return priceInDollars * this.getRate();
  },

  format(priceInDollars) {
    const amount = this.convert(priceInDollars);
    const currency = this.getActive();
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  },
};

// 使用示例
// CurrencyUtils.format(2999)  → "€27.77"（当前货币为 EUR 时）
// CurrencyUtils.getActive()   → "EUR"
// CurrencyUtils.getRate()     → 1.08

// 切换英寸和厘米的按钮动作
document.querySelectorAll('.kg-new').forEach(function(container) {
  const options = container.querySelectorAll('.input-select div');
  const sizeLabels = container.querySelectorAll('.size_width');

options.forEach(function(option) {
  option.addEventListener('click', function() {
    const prevUnit = container.querySelector('.input-select .active').textContent.trim();
    const newUnit = this.textContent.trim(); 

    // 切换 active
    options.forEach(o => o.classList.remove('active'));
    this.classList.add('active');
    sizeLabels.forEach(label => label.textContent = newUnit);

    // 转换已输入的数值
    if (prevUnit !== newUnit) {
      container.querySelectorAll('input[type="number"]').forEach(input => {
        if (input.value) {
          if (newUnit === 'cm') {
            input.value = (parseFloat(input.value) * 2.54).toFixed(2);
          } else {
            input.value = (parseFloat(input.value) / 2.54).toFixed(2);
          }
        }
      });
    }
    calculatePrice(false);
  });
});
});

    /**
     * ===============================================================
     *  全局变量：用于存储当前选择状态
     * ===============================================================
     */
    let state = {};

    // 页面初始原价（当计算失败或者数值为空时用于回填）
    const originalPriceHtml = $(".product__price .price .price-item").html();

    const metafieldsJson = document.getElementById("product-metafields");
        let metafields = {};
        if (metafieldsJson) {
            metafields = JSON.parse(metafieldsJson.textContent);
        }    

    // ===== 表单有效性 + 加购拦截（与时序无关）=====
    let formValid = false;

    // 统一入口：设置内部状态 + 视觉禁用
    function setFormValidity(valid) {
        formValid = !!valid;
        const $btn = $(".product-form__submit");
        $btn.prop("disabled", !formValid).toggleClass("disabled", !formValid);
    }

    (function setupCartGuard() {
        // 找到真正的 Shopify 加购表单
        const addForm = document.querySelector('product-form form, form[action*="/cart/add"]');
        if (!addForm) {
            console.warn('[cartGuard] 没找到加购表单，请确认选择器');
            return;
        }

        // 1) 提交拦截：捕获阶段执行，抢在主题的提交处理之前
        addForm.addEventListener('submit', function (e) {
            if (!formValid) {
                e.preventDefault();
                e.stopImmediatePropagation();   // 阻止主题自带的 AJAX 加购
                alert("Please fill in all required fields!");  // 这里可换成更友好的提示
            }
        }, true);

        // 2) 视觉自愈：主题把按钮启用、但必填项还没填完时，自动再禁回去
        const container = addForm.closest('product-form') || addForm.parentElement || addForm;
        new MutationObserver(function () {
            const btnEl = container.querySelector('.product-form__submit');
            if (btnEl && !formValid && !btnEl.disabled) {
                btnEl.disabled = true;
                btnEl.classList.add('disabled');
            }
        }).observe(container, { attributes: true, childList: true, subtree: true });
    })();

    /**
     * ===============================================================
     *  主计算函数：calculatePrice()
     *  @param {*} isManualTrigger 是否为手动触发（一般传 false）
     *  @param {*} panelAction     是否为 Panel 调整动作
     * ===============================================================
     */
    function calculatePrice(isManualTrigger = false, panelAction = "") {

        /**
         * -------------------------------------------------------------
         * 1. 收集所有字段
         * -------------------------------------------------------------
         */
        const formData = {
            productId: $('input[name="product_id"]').val(),
            variationID: $('input[name="variation_id"]').val() || 0,
            color: $('input[name="Color"]:checked').val(),
            selectedColorSlug: $("#pa_color-image").val() || "",
            selectedColorSKU: $('.select-option.swatch-wrapper[data-value="' + ($("#pa_color-image").val() || "") + '"]').attr("data-sku") || "",
            runnerType: $('input[name="mtsi_runner_type"]:checked').val() || "",
            openType: $('input[name="mtsi_open_type"]:checked').val(),
            finialStyle: $('input[name="mtsi_finial_style"]:checked').val(),
            ringOption: $('input[name="mtsi_ring_option"]:checked').val() || "",
            productRodType: $('input[name="mtsi_rod_type"]:checked').val(),

            headerType: $('input[name="mtsi_header_type"]:checked').val(),

            width: parseFloat($("#mtsi_custom_curtain_width").val()),
            unit: "inches",

            quantity: parseInt($('.quantity input[name="quantity"]').val() || "1"),

            // 单价和克重等参数
            linerUnitPrice: parseFloat(metafields.liner_unit_price) || 0,
            fabricUnitPrice: parseFloat(metafields.fabric_unit_price) || 0,
            fabricGSM: parseFloat(metafields.gram_per_square_inches) || 0,
            linerGSM: parseFloat(metafields.liner_gram_per_square_inches) || 0,

            patternType: "vertical",
            exchangeRate: parseFloat(1/7.0),

            startValue: "YES",
        };

        state = formData;



        /**
         * -------------------------------------------------------------
         * 2. Split Panels 处理逻辑
         * -------------------------------------------------------------
         */
        if (panelAction !== "") {
            if (formData.panelType === "Split Panels") {
                formData.quantity *= 2;
            }
        } else {
            if (formData.panelType === "Split Panels") {
                if (formData.quantity * 2 === 1) {
                    formData.quantity *= 2;
                }
            } else {
                if (formData.quantity === 1) {
                    formData.quantity = 1;
                    $('input[name="quantity"]').val(formData.quantity);
                }
            }
        }



        /**
         * -------------------------------------------------------------
         * 3. 基础价格计算
         * -------------------------------------------------------------
         */
        let curtainWidth  = parseFloat(formData.width);   // inch
        const activeUnit = document.querySelector('.input-select .active').textContent.trim();

        if (activeUnit === 'cm') {
        curtainWidth = parseFloat((curtainWidth / 2.54).toFixed(2));
        }
        let finalPrice = 0;
        let rodRate = 1;

        if (formData.productRodType === "Double Rod") {
            rodRate = 1.6;
        }

        finalPrice = (80 + curtainWidth * formData.fabricUnitPrice) * rodRate;
        //全站价格上涨10%
        //20260521 追加总价*1.5
        finalPrice = finalPrice *1.1*1.6*1.5;
        finalPrice = Math.floor(finalPrice * 100) / 100;

        formData.totalPrice = finalPrice;

        //传递数值到隐藏表单，提交到购物车
        
        document.getElementById('hiddenFinialStyle').value = formData.finialStyle ?? '';
        if (activeUnit === 'cm') {
            document.getElementById('hiddenWidth').value = formData.width + 'cm' ?? '';
        }else{
            document.getElementById('hiddenWidth').value = formData.width + '"' ?? '';
        }
        if(formData.ringOption){
            document.getElementById('hiddenRingOption').value = formData.ringOption ?? '';
        }
        if(formData.runnerType){
            document.getElementById('hiddenRunnerType').value = formData.runnerType ?? '';
            if(formData.openType && formData.runnerType == 'S Fold Runners'){
            document.getElementById('hiddenOpenType').value = formData.openType ?? '';
            }
        }
        document.getElementById('hiddenRodType').value = formData.productRodType ?? '';

        var appPriceInput = document.getElementById('custom-price-field');

        if (appPriceInput) {
            appPriceInput.value = finalPrice;
        }
        

        /**
         * -------------------------------------------------------------
         * 4. 更新展示项：颜色、配件、宽度显示等
         * -------------------------------------------------------------
         */
        $(".new-xqy .color").html(formData.selectedColorSKU);
        $(".new-xqy .finialStyle").html(formData.finialStyle);
        $(".new-xqy .runnerType").html(formData.runnerType);
        $(".new-xqy .ringOption").html(formData.ringOption);
        $(".new-xqy .rodType").html(formData.productRodType);

        if (formData.width) {
            if (activeUnit === 'cm') {
                $(".width_height_html").html(formData.width + 'cm W');
            }else{
                $(".width_height_html").html(formData.width + '"W');
            }
            $(".kuangao").css("border", "none");
        } else {
            $(".width_height_html").html("");
            $(".kuangao").css("border", "1px dashed red");
        }

        updateFinialImages(formData.color);

        /**
         * -------------------------------------------------------------
         * 5. 必填项检查 → 控制 Add to Cart 按钮可用性
         * -------------------------------------------------------------
         */

        (function () {
            let isValid = true;
            const color = state.color || '';
            if(color.includes('Lyne')){
                if (!state.finialStyle || !state.ringOption || !state.productRodType) {
                    isValid = false;
                }
            }else{
                if (!state.finialStyle || !state.productRodType || !state.runnerType) {
                    isValid = false;
                }
            }

            if (!state.width || state.width <= 1) {
                isValid = false;
            }

            setFormValidity(isValid); 
        })();



        /**
         * -------------------------------------------------------------
         * 6. 执行前端价格更新
         * -------------------------------------------------------------
         */
        if (finalPrice) {
            updatePriceDisplay(finalPrice, formData, formData.startValue);
        }
    }

setTimeout(function() {
    const color = $('input[name="Color"]:checked').val();
    
    if (color === 'Lyne-Champagne' || color === 'Lyne-Gold' || color === 'Lyne-Silver' || color === 'Zoe-Gold') {
        $('input[name="mtsi_finial_style"][value="Ball Finial"]').val('Crown Finial');
        $('input[name="mtsi_finial_style"][value="Crown Finial"]')
            .siblings('.wpcf7-list-item-label').text('Crown Finial')
            .end().closest('label').find('p').text('Crown Finial');

        $('input[name="mtsi_finial_style"][value="Cylinder Finial"]').val('Crystal Ball Finial');
        $('input[name="mtsi_finial_style"][value="Crystal Ball Finial"]')
            .siblings('.wpcf7-list-item-label').text('Crystal Ball Finial')
            .end().closest('label').find('p').text('Crystal Ball Finial');
    }

    updateFinialImages(color);
    calculatePrice(false);
}, 800);

    /**
     * ===============================================================
     *  WooCommerce 前端价格更新封装
     * ===============================================================
     */
    function updatePriceDisplay(calcPrice, data, startValue) {

        const priceBox = $(".product__price .price .price__regular");
        const hasSale = priceBox.find("del").length > 0 && priceBox.find("ins").length > 0;

        const qty = data.quantity || 1;

        const money = (v) =>
            CurrencyUtils.format(v.toFixed(2));

        const buildPriceString = (quantity, singlePrice) => {
            if (data.panelType === "Split Panels") {
                return `${qty} × ${money(singlePrice)}`;
            }
            if (singlePrice > 0) {
                const unitWord = qty > 1 ? "pieces" : "Piece";
                return `${qty} ${unitWord} × ${money(singlePrice)}`;
            }
            return originalPriceHtml;
        };

        console.log("Final Calculated Price:", calcPrice);


        /** 有促销价时处理 del + ins */
        if (hasSale) {
            const regular = parseFloat($("#mtsi_calculated_regular_price_elemnt").data("regular")) || 100;
            const sale = parseFloat($("#mtsi_calculated_regular_price_elemnt").data("sale")) || 90;

            const newRegularPrice = (regular / sale) * calcPrice;

            priceBox.find("del .price-item.price-item--regular").html(money(newRegularPrice));
            priceBox.find("ins .price-item.price-item--regular").html(buildPriceString(0, calcPrice));

            priceBox.find(".screen-reader-text:first").text(`Original price was: ${money(newRegularPrice)}`);
            priceBox.find(".screen-reader-text:last").text(`Current price is: ${money(calcPrice)}`);
        }

        /** 无促销价 */
        else {
            priceBox.find(".price-item.price-item--regular").html(buildPriceString(0, calcPrice));
            priceBox.html(buildPriceString(0, calcPrice));

            if (priceBox.find(".original-price").length === 0) {
                priceBox.append(
                    `<span class="original-price" style="display:none;">Original price: ${money(calcPrice)}</span>`
                );
            } else {
                priceBox.find(".original-price").text(`Original price: ${money(calcPrice)}`);
            }
        }

        // 更新隐藏展示字段
        $("#fetch_color_res_txt").html(data.selectedColorSlug || "");
        $("#fetch_width_res_txt").html(data.width ? data.width.toFixed(2) + '"' : "");
        $("#fetch_length_res_txt").html(data.height ? data.height.toFixed(2) + '"' : "");
        $("#fetch_header_res_txt").html(data.headerType || "");
        $("#fetch_lining_res_txt").html(data.lining || "");
    }



    /**
     * ===============================================================
     *  Add to Cart 点击事件，已作废
     * ===============================================================
     */
    $(".single_add_to_cart_button").on("click", function (event) {

        calculatePrice(false);
        event.preventDefault();

        submitAddToCart(state, state.totalPrice);
    });



    /**
     * ===============================================================
     *  AJAX 添加购物车动作,已作废
     * ===============================================================
     */
    function submitAddToCart(data, calcPrice) {

        if (!data.ringOption || !data.productRodType || isNaN(data.width)) {
            alert("Please fill in all required fields!");
            return;
        }
        if (!data.selectedColorSlug) {
            alert("Please choose a color");
            return false;
        }

        const ajaxData = {
            action: "cstm_add_to_cart",
            product_id: data.productId,
            variation_id: data.variationID,

            msti_pattern_type: data.patternType,
            mtsi_color_sku: data.selectedColorSKU,
            mtsi_color_swatch: data.selectedColorSlug,
            mtsi_finial_style: data.finialStyle,
            mtsi_ring_option: data.ringOption,
            mtsi_rod_type: data.productRodType,

            mtsi_custom_curtain_width: data.width,
            mtsi_custom_curtain_unit: data.unit,

            quantity: data.quantity,

            mtsi_custom_curtain_lining: data.lining,
            mtsi_custom_curtain_lining_color: data.liningColor,

            calculated_price: calcPrice,
            startValue: data.startValue,

            security: ajax_object.nonce
        };

        $.ajax({
            url: ajax_object.ajax_url,
            type: "POST",
            data: ajaxData,

            beforeSend: function () {
                $(".single_add_to_cart_button").prop("disabled", true).addClass("disabled");
            },

            success: function (response) {
                if (response.success) {
                    localStorage.setItem("NEWCARTADDITEM", "1");
                    location.reload();
                } else {
                    alert(response.data.msg);
                    $(".single_add_to_cart_button").prop("disabled", false).removeClass("disabled");
                }
            },

            error: function (xhr, status, error) {
                alert("An error occurred: " + error);
                $(".single_add_to_cart_button").prop("disabled", false).removeClass("disabled");
            }
        });
    }



    /**
     * ===============================================================
     *  所有触发重新计算的事件监听
     * ===============================================================
     */
    $('input[name="mtsi_runner_type"], \
       input[name="mtsi_finial_style"], \
       input[name="mtsi_ring_option"], \
       input[name="mtsi_mounting_type"], \
       input[name="mtsi_rod_type"], \
       #mtsi_custom_curtain_width, \
    .quantity input.quantity__input'
    ).on("change", function () { calculatePrice(false); });

    //变体颜色切换会把价格更改成变体价格，需要等待shopify的更改价格函数执行后，才可以触发更改价格
$('input[name="Color"]').on("change", function () {
    const color = $(this).val();

    // 第一步：先改 finial 选项的 value 和文字
    if (color === 'Lyne-Champagne' || color === 'Lyne-Gold' || color === 'Lyne-Silver' || color === 'Zoe-Gold') {
        $('input[name="mtsi_finial_style"][value="Ball Finial"]').val('Crown Finial');
        $('input[name="mtsi_finial_style"][value="Crown Finial"]')
            .siblings('.wpcf7-list-item-label').text('Crown Finial')
            .end().closest('label').find('p').text('Crown Finial');

        $('input[name="mtsi_finial_style"][value="Cylinder Finial"]').val('Crystal Ball Finial');
        $('input[name="mtsi_finial_style"][value="Crystal Ball Finial"]')
            .siblings('.wpcf7-list-item-label').text('Crystal Ball Finial')
            .end().closest('label').find('p').text('Crystal Ball Finial');

    } else if (color === 'Lyne-Black' || color === 'Lyne-White' || color === 'Lyne-Grey' || color === 'Zoe-Black') {
        $('input[name="mtsi_finial_style"][value="Crown Finial"]').val('Ball Finial');
        $('input[name="mtsi_finial_style"][value="Ball Finial"]')
            .siblings('.wpcf7-list-item-label').text('Ball Finial')
            .end().closest('label').find('p').text('Ball Finial');

        $('input[name="mtsi_finial_style"][value="Crystal Ball Finial"]').val('Cylinder Finial');
        $('input[name="mtsi_finial_style"][value="Cylinder Finial"]')
            .siblings('.wpcf7-list-item-label').text('Cylinder Finial')
            .end().closest('label').find('p').text('Cylinder Finial');
    }

    // 第二步：立即更新图片
    updateFinialImages(color);

    // 第三步：等 Shopify 变体价格更新完再重算价格
    setTimeout(() => { calculatePrice(false); }, 1000);
});

    // 打开类型隐藏显示触发
    $('input[name="mtsi_runner_type"]').on("change", function () {
        const selectedrunner = $(this).val();
        if(selectedrunner == 'S Fold Runners'){
            $('.open_type').show();
        }else{
            $('.open_type').hide();
            document.getElementById('hiddenOpenType').value = '';
        }
    });

    $('input[name="mtsi_open_type"]').on("change", function () {
        calculatePrice(false);
    });

    $("#mtsi_custom_curtain_width, #mtsi_custom_curtain_height").keypress(function (e) {
        calculatePrice(false);
        if (e.which === 13) e.preventDefault();
    });
    $("#mtsi_custom_curtain_width, #mtsi_custom_curtain_height").blur(function () {
        calculatePrice(false);
    });



    /**
     * ===============================================================
     *  页面初始化行为：展开 minicart + checkout 修复
     * ===============================================================
     */
    let initFlag = 0;

    setTimeout(function () {

        if (initFlag === 0) {
            initFlag = 1;

            if (localStorage.getItem("NEWCARTADDITEM")) {
                $(".lakit-cart__heading-link").click();
                localStorage.removeItem("NEWCARTADDITEM");
            }

            if ($("form.woocommerce-checkout ul.uael-order-review-table li + a").length) {

                $("form.woocommerce-checkout ul.uael-order-review-table li.table-row.cart_item.st-item-meta > a:first-child").remove();

                $("form.woocommerce-checkout ul.uael-order-review-table li + a").each(function () {
                    $(this).remove();
                });
            }
        }

    }, 1500);

}); // END document.ready